module.exports = __webpack_public_path__ + "static/media/playStore.eca6c71b.svg";